// import axios from "axios";
// import { createContext, useContext, useEffect, useState } from "react";

// const WishlistContext = createContext();

// export const WishlistProvider = ({children}) => {
//     const [wishlistItems, setWishlistItems] = useState([]);
//     // const userId = sessionStorage.getItem("userId");
// const [userId, setUserId] = useState(
//   sessionStorage.getItem("userId")
// );

//     const loadWishlist = async() =>{
//         if (userId) {
//         try{
//             const res = await axios.post(
//                 "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
//                 {user_id:userId}
//             );
//             if(res.data.status === "true"){
//                 const ids = res.data.data.map(item => item.prod_id);
//                 setWishlistItems(ids);
//             }
//         }catch(error){
//             console.error(error);
//         }
//     }else{
//         // Guest user
//         const localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
//         setWishlistItems(localWish);
//     }
//     };
//     //Toggle Wishlist
//     const toggleWishlist = async(prod_id)=>{
//         if(userId){
//             try{
//                 if(wishlistItems.includes(prod_id)){
//                     await axios.post(
//                         "https://ecom.cyberathon.com/index.php/Api/delete_wish_list",
//                         {user_id:userId, wish_id:prod_id}
//                     );
//                     setWishlistItems(prev =>
//                         prev.filter(id => id !== prod_id)
//                     );
//                 }else{
//                     await axios.post(
//                          "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//                     );
//                     setWishlistItems(prev => [...prev, prod_id]);
//                 }
//             }catch(error){
//                 console.error(error);
//             }
//         }else{
// // Guest user
//       let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//       if (localWish.includes(prod_id)) {
//         localWish = localWish.filter(id => id !== prod_id);
//       } else {
//         localWish.push(prod_id);
//       }

//       localStorage.setItem("guest_wishlist", JSON.stringify(localWish));
//       setWishlistItems(localWish);
    
//         }
//     };
//     // 🔹 Merge Guest Wishlist After Login
//   const mergeWishlistAfterLogin = async () => {
//     if (!userId) return;

//     const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//     if (guestWishlist.length > 0) {
//     //   for (let prod_id of guestWishlist) {
//     //     await axios.post(
//     //       "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//     //       { user_id: userId, prod_id }
//     //     );
//     //   }
// for (let prod_id of guestWishlist) {

//  if (!wishlistItems.includes(prod_id)) {

//   await axios.post(
//    "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//    { user_id: userId, prod_id }
//   );

//  }

// }

//       localStorage.removeItem("guest_wishlist");
//       loadWishlist();
//     }
//   };

//   useEffect(() => {
//     loadWishlist();
//   }, [userId]);

//   return (
//     <WishlistContext.Provider
//       value={{ wishlistItems, toggleWishlist, mergeWishlistAfterLogin, setUserId }}
//     >
//       {children}
//     </WishlistContext.Provider>
//   );
// };
// export const useWishlist = () => useContext(WishlistContext);



// claude 14 feb
// import axios from "axios";
// import { createContext, useContext, useEffect, useState } from "react";

// const WishlistContext = createContext();

// export const WishlistProvider = ({ children }) => {
//   const [wishlistItems, setWishlistItems] = useState([]);
//   const [userId, setUserId] = useState(sessionStorage.getItem("userId"));

//   // ✅ Load wishlist (guest ya logged-in user)
//   const loadWishlist = async () => {
//     if (userId) {
//       // 🔹 LOGGED-IN USER
//       try {
//         const res = await axios.post(
//           "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
//           { user_id: userId }
//         );
//         if (res.data.status === "true") {
//           const ids = res.data.data.map((item) => item.prod_id);
//           setWishlistItems(ids);
//         }
//       } catch (error) {
//         console.error("Wishlist fetch error:", error);
//       }
//     } else {
//       // 🔹 GUEST USER
//       const localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
//       setWishlistItems(localWish);
//     }
//   };

//   // ✅ Toggle Wishlist (Add/Remove)
//   const toggleWishlist = async (prod_id) => {
//     if (userId) {
//       // 🔹 LOGGED-IN USER
//       try {
//         if (wishlistItems.includes(prod_id)) {
//           // ❌ REMOVE from wishlist
//           await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/delete_wish_list",
//             { user_id: userId, wish_id: prod_id }
//           );
//           setWishlistItems((prev) => prev.filter((id) => id !== prod_id));
//         } else {
//           // ✅ ADD to wishlist
//           await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
//           setWishlistItems((prev) => [...prev, prod_id]);
//         }
//       } catch (error) {
//         console.error("Wishlist API error:", error);
//       }
//     } else {
//       // 🔹 GUEST USER (localStorage)
//       let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//       if (localWish.includes(prod_id)) {
//         localWish = localWish.filter((id) => id !== prod_id);
//       } else {
//         localWish.push(prod_id);
//       }

//       localStorage.setItem("guest_wishlist", JSON.stringify(localWish));
//       setWishlistItems(localWish);
//     }
//   };

//   // ✅ Merge Guest Wishlist After Login
//   const mergeWishlistAfterLogin = async () => {
//     if (!userId) return;

//     const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//     if (guestWishlist.length > 0) {
//       try {
//         // Backend mein har guest item add karo
//         for (let prod_id of guestWishlist) {
//           await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
//         }

//         // ✅ Guest wishlist clear karo localStorage se
//         localStorage.removeItem("guest_wishlist");

//         // ✅ Backend se fresh wishlist load karo
//         await loadWishlist();
//       } catch (error) {
//         console.error("Merge wishlist error:", error);
//       }
//     } else {
//       // Agar guest wishlist khali hai, to seedha backend se load karo
//       await loadWishlist();
//     }
//   };

//   // ✅ Clear Wishlist on Logout
//   const clearWishlist = () => {
//     setWishlistItems([]);
//     localStorage.removeItem("guest_wishlist"); // Guest data bhi clear
//   };

//   // ✅ Load wishlist jab userId change ho
//   useEffect(() => {
//     loadWishlist();
//   }, [userId]);

//   return (
//     <WishlistContext.Provider
//       value={{
//         wishlistItems,
//         toggleWishlist,
//         mergeWishlistAfterLogin,
//         clearWishlist,
//         setUserId,
//       }}
//     >
//       {children}
//     </WishlistContext.Provider>
//   );
// };

// export const useWishlist = () => useContext(WishlistContext);

// ye wish_id change krnese pehle ka code hai
// import axios from "axios";
// import { createContext, useContext, useEffect, useState } from "react";

// const WishlistContext = createContext();

// export const WishlistProvider = ({ children }) => {
//   const [wishlistItems, setWishlistItems] = useState([]); // Array of prod_ids
//   const [wishlistData, setWishlistData] = useState([]); // Full data with wish_id
//   const [userId, setUserId] = useState(sessionStorage.getItem("userId"));

//   // ✅ Load wishlist with full data (including wish_id)
//   const loadWishlist = async () => {
//     if (userId) {
//       try {
//         const res = await axios.post(
//           "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
//           { user_id: userId }
//         );

//         if (res.data.status === "true") {
//           const items = res.data.data;
          
//           // Store full data (with wish_id)
//           setWishlistData(items);
          
//           // Store only prod_ids for easy checking
//           const prodIds = items.map((item) => item.prod_id);
//           setWishlistItems(prodIds);
          
//           console.log("✅ Wishlist loaded:", items);
//         } else {
//           setWishlistData([]);
//           setWishlistItems([]);
//         }
//       } catch (error) {
//         console.error("❌ Wishlist fetch error:", error);
//         setWishlistData([]);
//         setWishlistItems([]);
//       }
//     } else {
//       // Guest user - localStorage
//       const localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
//       setWishlistItems(localWish);
//       setWishlistData([]);
//     }
//   };

//   // ✅ Toggle Wishlist (Add/Remove)
//   const toggleWishlist = async (prod_id) => {
//     console.log("🔥 Toggle Wishlist called for prod_id:", prod_id);
    
//     if (userId) {
//       // 🔹 LOGGED-IN USER
//       try {
//         if (wishlistItems.includes(prod_id)) {
//           // ❌ REMOVE from wishlist
          
//           // Find wish_id from full data
//           const wishItem = wishlistData.find(item => item.prod_id === prod_id);
          
//           if (!wishItem) {
//             console.error("❌ wish_id not found for prod_id:", prod_id);
//             return;
//           }
          
//           const wish_id = wishItem.wish_id;
          
//           console.log("🗑️ DELETING from wishlist:", {
//             user_id: userId,
//             wish_id: wish_id,
//             prod_id: prod_id
//           });
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/delete_wish_list",
//             { 
//               user_id: userId, 
//               wish_id: wish_id  // ✅ Backend ko wish_id bhejo
//             }
//           );
          
//           console.log("📥 Delete API Response:", response.data);
          
//           if (response.data.status === "true") {
//             // Remove from state
//             setWishlistItems((prev) => prev.filter((id) => id !== prod_id));
//             setWishlistData((prev) => prev.filter((item) => item.prod_id !== prod_id));
//             console.log("✅ Item deleted successfully");
//           } else {
//             console.error("❌ Delete failed:", response.data.message);
//             alert(response.data.message);
//           }
          
//         } else {
//           // ✅ ADD to wishlist
          
//           console.log("➕ ADDING to wishlist:", {
//             user_id: userId,
//             prod_id: prod_id
//           });
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
          
//           console.log("📥 Add API Response:", response.data);
          
//           if (response.data.status === "true") {
//             // Add to state
//             setWishlistItems((prev) => [...prev, prod_id]);
            
//             // Reload full wishlist to get wish_id
//             await loadWishlist();
            
//             console.log("✅ Item added successfully");
//           } else {
//             console.error("❌ Add failed:", response.data.message);
//             alert(response.data.message);
//           }
//         }
//       } catch (error) {
//         console.error("❌ Wishlist API error:", error.response?.data || error);
//         alert("Error processing wishlist");
//       }
//     } else {
//       // 🔹 GUEST USER (localStorage)
//       console.log("🔹 Guest user - Using localStorage");
      
//       let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//       if (localWish.includes(prod_id)) {
//         localWish = localWish.filter((id) => id !== prod_id);
//         console.log("❌ Removed from localStorage");
//       } else {
//         localWish.push(prod_id);
//         console.log("✅ Added to localStorage");
//       }

//       localStorage.setItem("guest_wishlist", JSON.stringify(localWish));
//       setWishlistItems(localWish);
//     }
//   };

//   // ✅ Merge Guest Wishlist After Login
//   const mergeWishlistAfterLogin = async () => {
//     if (!userId) return;

//     const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//     if (guestWishlist.length > 0) {
//       try {
//         console.log("🔄 Merging guest wishlist:", guestWishlist);
        
//         // Backend mein har guest item add karo
//         for (let prod_id of guestWishlist) {
//           await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
//         }

//         // Guest wishlist clear karo
//         localStorage.removeItem("guest_wishlist");
        
//         // Backend se fresh wishlist load karo
//         await loadWishlist();
        
//         console.log("✅ Guest wishlist merged successfully");
//       } catch (error) {
//         console.error("❌ Merge wishlist error:", error);
//       }
//     } else {
//       // Agar guest wishlist khali hai
//       await loadWishlist();
//     }
//   };

//   // ✅ Clear Wishlist on Logout
//   const clearWishlist = () => {
//     setWishlistItems([]);
//     setWishlistData([]);
//     localStorage.removeItem("guest_wishlist");
//     console.log("🧹 Wishlist cleared");
//   };

//   // ✅ Load wishlist when userId changes
//   useEffect(() => {
//     loadWishlist();
//   }, [userId]);

//   return (
//     <WishlistContext.Provider
//       value={{
//         wishlistItems,
//         toggleWishlist,
//         mergeWishlistAfterLogin,
//         clearWishlist,
//         setUserId,
//         loadWishlist, // ✅ Export for manual reload
//       }}
//     >
//       {children}
//     </WishlistContext.Provider>
//   );
// };

// export const useWishlist = () => useContext(WishlistContext);


// After prod_id changes from wish_id 14 feb
//Gm 16-02-2026
// import axios from "axios";
// import { createContext, useContext, useEffect, useState } from "react";

// const WishlistContext = createContext();

// export const WishlistProvider = ({ children }) => {
//   const [wishlistItems, setWishlistItems] = useState([]); // Array of prod_ids
//   const [userId, setUserId] = useState(sessionStorage.getItem("userId"));

//   // ✅ Load wishlist (prod_ids only)
//   const loadWishlist = async () => {
//     if (userId) {
//       try {
//         const res = await axios.post(
//           "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
//           { user_id: userId }
//         );

//         if (res.data.status === "true") {
//           // Extract only prod_ids
//           const prodIds = res.data.data.map((item) => item.prod_id);
//           setWishlistItems(prodIds);
//           console.log("✅ Wishlist loaded:", prodIds);
//         } else {
//           setWishlistItems([]);
//         }
//       } catch (error) {
//         console.error("❌ Wishlist fetch error:", error);
//         setWishlistItems([]);
//       }
//     } else {
//       // Guest user - localStorage
//       const localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
//       setWishlistItems(localWish);
//     }
//   };

//   // ✅ Toggle Wishlist (Add/Remove)
//   const toggleWishlist = async (prod_id) => {
//     console.log("🔥 Toggle Wishlist called for prod_id:", prod_id);
    
//     if (userId) {
//       // 🔹 LOGGED-IN USER
//       try {
//         if (wishlistItems.includes(prod_id)) {
//           // ❌ REMOVE from wishlist
//           console.log("🗑️ DELETING from wishlist:", {
//             user_id: userId,
//             prod_id: prod_id
//           });
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/delete_wish_list",
//             { 
//               user_id: userId, 
//               prod_id: prod_id  // ✅ Backend ab prod_id accept karta hai
//             }
//           );
          
//           console.log("📥 Delete API Response:", response.data);
          
//           if (response.data.status === "true") {
//             // Remove from state
//             setWishlistItems((prev) => prev.filter((id) => id !== prod_id));
//             console.log("✅ Item deleted successfully");
//           } else {
//             console.error("❌ Delete failed:", response.data.message);
//             alert(response.data.message);
//           }
          
//         } else {
//           // ✅ ADD to wishlist
//           console.log("➕ ADDING to wishlist:", {
//             user_id: userId,
//             prod_id: prod_id
//           });
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
          
//           console.log("📥 Add API Response:", response.data);
          
//           if (response.data.status === "true") {
//             // Add to state
//             setWishlistItems((prev) => [...prev, prod_id]);
//             console.log("✅ Item added successfully");
//           } else {
//             console.error("❌ Add failed:", response.data.message);
//             alert(response.data.message);
//           }
//         }
//       } catch (error) {
//         console.error("❌ Wishlist API error:", error.response?.data || error);
//         alert("Error processing wishlist");
//       }
//     } else {
//       // 🔹 GUEST USER (localStorage)
//       console.log("🔹 Guest user - Using localStorage");
      
//       // let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//       // if (localWish.includes(prod_id)) {
//       //   localWish = localWish.filter((id) => id !== prod_id);
//       //   console.log("❌ Removed from localStorage");
//       // } else {
//       //   localWish.push(prod_id);
//       //   console.log("✅ Added to localStorage");
//       // }
// const id = String(prod_id);
// let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

// if (localWish.includes(id)) {
//   localWish = localWish.filter((item) => item !== id);
// } else {
//   localWish.push(id);
// }
//       localStorage.setItem("guest_wishlist", JSON.stringify(localWish));
//       setWishlistItems(localWish);
//     }
//   };

//   // ✅ Merge Guest Wishlist After Login
//   const mergeWishlistAfterLogin = async () => {
//     if (!userId) return;

//     const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//     if (guestWishlist.length > 0) {
//       try {
//         console.log("🔄 Merging guest wishlist:", guestWishlist);
        
//         // Backend mein har guest item add karo
//         // for (let prod_id of guestWishlist) {
//         //   await axios.post(
//         //     "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//         //     { user_id: userId, prod_id }
//         //   );
//         // }
// for (let prod_id of guestWishlist) {
//   await axios.post(
//     "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//     { user_id: userId, prod_id: Number(prod_id) }
//   );
// }

//         // Guest wishlist clear karo
//         localStorage.removeItem("guest_wishlist");
        
//         // Backend se fresh wishlist load karo
//         await loadWishlist();
        
//         console.log("✅ Guest wishlist merged successfully");
//       } catch (error) {
//         console.error("❌ Merge wishlist error:", error);
//       }
//     } else {
//       // Agar guest wishlist khali hai
//       await loadWishlist();
//     }
//   };

//   // ✅ Clear Wishlist on Logout
//   const clearWishlist = () => {
//     setWishlistItems([]);
//     localStorage.removeItem("guest_wishlist");
//     console.log("🧹 Wishlist cleared");
//   };

//   // ✅ Load wishlist when userId changes
//   useEffect(() => {
//     loadWishlist();
//   }, [userId]);

//   return (
//     <WishlistContext.Provider
//       value={{
//         wishlistItems,
//         toggleWishlist,
//         mergeWishlistAfterLogin,
//         clearWishlist,
//         setUserId,
//         loadWishlist,
//       }}
//     >
//       {children}
//     </WishlistContext.Provider>
//   );
// };

// export const useWishlist = () => useContext(WishlistContext);

// After claud in gm 1 try
// import axios from "axios";
// import { createContext, useContext, useEffect, useState } from "react";

// const WishlistContext = createContext();

// export const WishlistProvider = ({ children }) => {
//   const [wishlistItems, setWishlistItems] = useState([]); // Array of prod_ids
//   const [userId, setUserId] = useState(sessionStorage.getItem("userId"));

//   // ✅ Load wishlist (prod_ids only)
//   const loadWishlist = async () => {
//     if (userId) {
//       // 🔹 LOGGED-IN USER
//       try {
//         const res = await axios.post(
//           "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
//           { user_id: userId }
//         );

//         if (res.data.status === "true") {
//           const prodIds = res.data.data.map((item) => item.prod_id);
//           setWishlistItems(prodIds);
//           console.log("✅ Wishlist loaded (logged-in):", prodIds);
//         } else {
//           setWishlistItems([]);
//         }
//       } catch (error) {
//         console.error("❌ Wishlist fetch error:", error);
//         setWishlistItems([]);
//       }
//     } else {
//       // 🔹 GUEST USER - localStorage se load karo
//       const localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
//       setWishlistItems(localWish);
//       console.log("✅ Guest wishlist loaded from localStorage:", localWish);
//     }
//   };

//   // ✅ Toggle Wishlist (Add/Remove)
//   const toggleWishlist = async (prod_id) => {
//     console.log("🔥 Toggle Wishlist called for prod_id:", prod_id);
    
//     if (userId) {
//       // 🔹 LOGGED-IN USER
//       try {
//         if (wishlistItems.includes(prod_id)) {
//           // ❌ REMOVE from wishlist
//           console.log("🗑️ DELETING from wishlist:", {
//             user_id: userId,
//             prod_id: prod_id
//           });
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/delete_wish_list",
//             { 
//               user_id: userId, 
//               prod_id: prod_id
//             }
//           );
          
//           console.log("📥 Delete API Response:", response.data);
          
//           if (response.data.status === "true") {
//             setWishlistItems((prev) => prev.filter((id) => id !== prod_id));
//             console.log("✅ Item deleted successfully");
//           } else {
//             console.error("❌ Delete failed:", response.data.message);
//             alert(response.data.message);
//           }
          
//         } else {
//           // ✅ ADD to wishlist
//           console.log("➕ ADDING to wishlist:", {
//             user_id: userId,
//             prod_id: prod_id
//           });
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
          
//           console.log("📥 Add API Response:", response.data);
          
//           if (response.data.status === "true") {
//             setWishlistItems((prev) => [...prev, prod_id]);
//             console.log("✅ Item added successfully");
//           } else {
//             console.error("❌ Add failed:", response.data.message);
//             alert(response.data.message);
//           }
//         }
//       } catch (error) {
//         console.error("❌ Wishlist API error:", error.response?.data || error);
//         alert("Error processing wishlist");
//       }
//     } else {
//       // 🔹 GUEST USER (localStorage)
//       console.log("🔹 Guest user - Using localStorage");
      
//       let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

//       if (localWish.includes(prod_id)) {
//         localWish = localWish.filter((id) => id !== prod_id);
//         console.log("❌ Removed from localStorage:", prod_id);
//       } else {
//         localWish.push(prod_id);
//         console.log("✅ Added to localStorage:", prod_id);
//       }

//       localStorage.setItem("guest_wishlist", JSON.stringify(localWish));
//       setWishlistItems(localWish);
//       console.log("💾 localStorage updated:", localWish);
//     }
//   };

//   // ✅ Merge Guest Wishlist After Login
//   const mergeWishlistAfterLogin = async () => {
//     console.log("🔄 mergeWishlistAfterLogin called");
//     console.log("🔹 Current userId:", userId);
    
//     if (!userId) {
//       console.warn("⚠️ No userId found, skipping merge");
//       return;
//     }

//     const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
//     console.log("🔹 Guest wishlist from localStorage:", guestWishlist);

//     if (guestWishlist.length > 0) {
//       try {
//         console.log("🔄 Merging guest wishlist:", guestWishlist);
        
//         // Backend mein har guest item add karo
//         for (let prod_id of guestWishlist) {
//           console.log(`➕ Adding prod_id ${prod_id} to user ${userId}'s wishlist`);
          
//           const response = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
//             { user_id: userId, prod_id }
//           );
          
//           console.log(`📥 Add response for ${prod_id}:`, response.data);
//         }

//         // Guest wishlist clear karo
//         localStorage.removeItem("guest_wishlist");
//         console.log("🧹 Guest wishlist cleared from localStorage");
        
//         // Backend se fresh wishlist load karo
//         await loadWishlist();
        
//         console.log("✅ Guest wishlist merged successfully");
//       } catch (error) {
//         console.error("❌ Merge wishlist error:", error);
//       }
//     } else {
//       console.log("ℹ️ No guest wishlist to merge");
//       // Agar guest wishlist khali hai, sirf backend wishlist load karo
//       await loadWishlist();
//     }
//   };

//   // ✅ Clear Wishlist on Logout
//   const clearWishlist = () => {
//     setWishlistItems([]);
//     console.log("🧹 Wishlist cleared (session only, localStorage retained for guest)");
//   };

//   // ✅ Load wishlist when userId changes
//   useEffect(() => {
//     console.log("🔄 userId changed:", userId);
//     loadWishlist();
//   }, [userId]);

//   return (
//     <WishlistContext.Provider
//       value={{
//         wishlistItems,
//         toggleWishlist,
//         mergeWishlistAfterLogin,
//         clearWishlist,
//         setUserId,
//         loadWishlist,
//       }}
//     >
//       {children}
//     </WishlistContext.Provider>
//   );
// };

// export const useWishlist = () => useContext(WishlistContext);


// 2nd try of claude 16feb
import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState([]); // Array of prod_ids
  const [userId, setUserId] = useState(sessionStorage.getItem("userId"));

  // ✅ Load wishlist (prod_ids only)
  const loadWishlist = async () => {
    if (userId) {
      // 🔹 LOGGED-IN USER
      try {
        const res = await axios.post(
          "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
          { user_id: userId }
        );

        if (res.data.status === "true") {
          const prodIds = res.data.data.map((item) => item.prod_id);
          setWishlistItems(prodIds);
          console.log("✅ Wishlist loaded (logged-in):", prodIds);
        } else {
          setWishlistItems([]);
        }
      } catch (error) {
        console.error("❌ Wishlist fetch error:", error);
        setWishlistItems([]);
      }
    } else {
      // 🔹 GUEST USER - localStorage se load karo
      const localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
      setWishlistItems(localWish);
      console.log("✅ Guest wishlist loaded from localStorage:", localWish);
    }
  };

  // ✅ Toggle Wishlist (Add/Remove)
  const toggleWishlist = async (prod_id) => {
    console.log("🔥 Toggle Wishlist called for prod_id:", prod_id);
    
    if (userId) {
      // 🔹 LOGGED-IN USER
      try {
        if (wishlistItems.includes(prod_id)) {
          // ❌ REMOVE from wishlist
          console.log("🗑️ DELETING from wishlist:", {
            user_id: userId,
            prod_id: prod_id
          });
          
          const response = await axios.post(
            "https://ecom.cyberathon.com/index.php/Api/delete_wish_list",
            { 
              user_id: userId, 
              prod_id: prod_id
            }
          );
          
          console.log("📥 Delete API Response:", response.data);
          
          if (response.data.status === "true") {
            setWishlistItems((prev) => prev.filter((id) => id !== prod_id));
            console.log("✅ Item deleted successfully");
          } else {
            console.error("❌ Delete failed:", response.data.message);
            alert(response.data.message);
          }
          
        } else {
          // ✅ ADD to wishlist
          console.log("➕ ADDING to wishlist:", {
            user_id: userId,
            prod_id: prod_id
          });
          
          const response = await axios.post(
            "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
            { user_id: userId, prod_id }
          );
          
          console.log("📥 Add API Response:", response.data);
          
          if (response.data.status === "true") {
            setWishlistItems((prev) => [...prev, prod_id]);
            console.log("✅ Item added successfully");
          } else {
            console.error("❌ Add failed:", response.data.message);
            alert(response.data.message);
          }
        }
      } catch (error) {
        console.error("❌ Wishlist API error:", error.response?.data || error);
        alert("Error processing wishlist");
      }
    } else {
      // 🔹 GUEST USER (localStorage)
      console.log("🔹 Guest user - Using localStorage");
      
      let localWish = JSON.parse(localStorage.getItem("guest_wishlist")) || [];

      if (localWish.includes(prod_id)) {
        localWish = localWish.filter((id) => id !== prod_id);
        console.log("❌ Removed from localStorage:", prod_id);
      } else {
        localWish.push(prod_id);
        console.log("✅ Added to localStorage:", prod_id);
      }

      localStorage.setItem("guest_wishlist", JSON.stringify(localWish));
      setWishlistItems(localWish);
      console.log("💾 localStorage updated:", localWish);
    }
  };

  // ✅ Merge Guest Wishlist After Login
  const mergeWishlistAfterLogin = async (loggedInUserId) => {
    console.log("🔄 mergeWishlistAfterLogin called");
    
    // ✅ Parameter se userId lo, ya phir context se
    const currentUserId = loggedInUserId || userId;
    console.log("🔹 Using userId:", currentUserId);
    
    if (!currentUserId) {
      console.warn("⚠️ No userId found, skipping merge");
      return;
    }

    const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
    console.log("🔹 Guest wishlist from localStorage:", guestWishlist);

    if (guestWishlist.length > 0) {
      try {
        console.log("🔄 Merging guest wishlist:", guestWishlist);
        
        // Backend mein har guest item add karo
        for (let prod_id of guestWishlist) {
          console.log(`➕ Adding prod_id ${prod_id} to user ${currentUserId}'s wishlist`);
          
          const response = await axios.post(
            "https://ecom.cyberathon.com/index.php/Api/add_wishlist",
            { user_id: currentUserId, prod_id }
          );
          
          console.log(`📥 Add response for ${prod_id}:`, response.data);
        }

        // Guest wishlist clear karo
        localStorage.removeItem("guest_wishlist");
        console.log("🧹 Guest wishlist cleared from localStorage");
        
        // Backend se fresh wishlist load karo
        const res = await axios.post(
          "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
          { user_id: currentUserId }
        );

        if (res.data.status === "true") {
          const prodIds = res.data.data.map((item) => item.prod_id);
          setWishlistItems(prodIds);
          console.log("✅ Merged wishlist loaded:", prodIds);
        }
        
        console.log("✅ Guest wishlist merged successfully");
      } catch (error) {
        console.error("❌ Merge wishlist error:", error);
      }
    } else {
      console.log("ℹ️ No guest wishlist to merge");
      // Agar guest wishlist khali hai, sirf backend wishlist load karo
      try {
        const res = await axios.post(
          "https://ecom.cyberathon.com/index.php/Api/list_wishlist",
          { user_id: currentUserId }
        );

        if (res.data.status === "true") {
          const prodIds = res.data.data.map((item) => item.prod_id);
          setWishlistItems(prodIds);
          console.log("✅ Wishlist loaded:", prodIds);
        }
      } catch (error) {
        console.error("❌ Wishlist fetch error:", error);
      }
    }
  };

  // ✅ Clear Wishlist on Logout
  const clearWishlist = () => {
    setWishlistItems([]);
    console.log("🧹 Wishlist cleared (session only, localStorage retained for guest)");
  };

  // ✅ Load wishlist when userId changes
  useEffect(() => {
    console.log("🔄 userId changed:", userId);
    loadWishlist();
  }, [userId]);

  return (
    <WishlistContext.Provider
      value={{
        wishlistItems,
        toggleWishlist,
        mergeWishlistAfterLogin,
        clearWishlist,
        setUserId,
        loadWishlist,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);